import { TextField, Toolbar } from "@mui/material";
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { ReactElement, useState } from "react";
import { useConfirmDialog } from "../../../hooks/useConfirmDialog";
import { ConfirmDialog } from "../ConfirmDialog";

interface DataTableToolbarProps {
  selected: number[];
  title?: string;
  onDelete?: (ids: number[]) => void;
  onSearch?: (query: string) => void;
  hideFilter?: boolean;
  hideDeleteButton?: boolean;
  toolbarAdditionalRightElement?: ReactElement;
}

export const DataTableToolbar = (props: DataTableToolbarProps) => {
  const { title, selected, onDelete, onSearch, hideFilter, hideDeleteButton, toolbarAdditionalRightElement } = props;
  const [searchQuery, setSearchQuery] = useState<string>('');
  const { isOpen, config, openDialog, closeDialog } = useConfirmDialog();

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value;
    setSearchQuery(query);
    onSearch && onSearch(query);
  };


  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(selected.length > 0 && {
          bgcolor: (theme) =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        }),
      }}
    >
      {selected.length > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {selected.length} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          {title}
        </Typography>
      )}
      {
        !hideFilter && (
          <>
            { toolbarAdditionalRightElement }
            <TextField
              variant="outlined"
              size="medium"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearchChange}
              sx={{ marginRight: 2 }}
            />
            {!hideDeleteButton && selected.length > 0 ? (
              <Tooltip title="Delete">
                <IconButton onClick={() => 
                  openDialog(
                    "Confirm Deletion",
                    `Are you sure you want to delete selected rows?`,
                    () => onDelete && onDelete(selected)
                  )
                }>
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            ) : (
              // <Tooltip title="Filter list">
                <IconButton>
                  <FilterListIcon />
                </IconButton>
              // </Tooltip>
            )}
          </>
        )
      }
      <ConfirmDialog
        open={isOpen}
        title={config.title}
        description={config.description}
        onConfirm={config.onConfirm}
        onClose={closeDialog}
      />
    </Toolbar>
  );
}